import React from "react";
import { Badge as AntdBadge, BadgeProps as AntdBadgeProps } from "antd";

export type BadgeProps = AntdBadgeProps;

const Badge = (props: BadgeProps) => {
  return <AntdBadge {...props} />;
};

export default Badge;

Badge.Ribbon = AntdBadge.Ribbon;
